import { Component, OnInit } from '@angular/core';
import { TranslateService as langService } from '../../i18n/translate.service';
import { TranslatePipe } from '../../i18n/translate.pipe';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/Services/common.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
declare var config;
@Component({
  selector: 'app-account-delete-modal',
  templateUrl: './account-delete-modal.component.html',
  styleUrls: ['./account-delete-modal.component.css']
})
export class AccountDeleteModalComponent implements OnInit {
  public translatePipe: any;
  isUserCanDeleteAccount: any;
  CustomerInfo: any;
  EmailAddress: any;
  UserInfo: any;
  userdetails: any;
  mailsentnotification: boolean;
  supportemail: any;
  AlreadyDeleted: boolean;
  constructor(private _translatelang: langService, private spinner: NgxSpinnerService, private _service: CommonService,
    private router: Router, public activeModal: NgbActiveModal) {
    this.translatePipe = new TranslatePipe(_translatelang);
  }

  ngOnInit() {
    this.spinner.show();
    this.supportemail = config.supportEmail;
    this.checkuser();
    this.CustomerInfo = JSON.parse(sessionStorage.getItem('customerinfo'));
    this.EmailAddress = this.CustomerInfo.EmailAddress;
  }

  checkuser() {
    debugger
    this.UserInfo = JSON.parse(sessionStorage.getItem('customerinfo'));
    var parameters = {
      EmailAddress: this.UserInfo.EmailAddress,
    }
    this._service.Post(parameters, 'api/CheckDeleteAccount').then(
      resultData => {
        debugger
        var result = JSON.parse(resultData);
        if (result != null) {
          if (!result.Status && result.Message === 'AlreadyDeleted') {
            this.AlreadyDeleted = true;
          }
          if (result.Status) {
            this.isUserCanDeleteAccount = true;
          } else {
            this.isUserCanDeleteAccount = false;
          }
        }
        else {
          console.log("Some Error occur");
        }
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        if (error.status === 401) {
          this.router.navigate(['/unauthorized']);
        }
        console.log(error);
      });
  }
  checkdeleteuseraccount()
  {
    this.UserInfo = JSON.parse(sessionStorage.getItem('customerinfo'));
    var parameters = {
      EmailAddress: this.UserInfo.EmailAddress,
    }
    this.spinner.show();
    this._service.Post(parameters, 'api/CheckDeleteAccount').then(
      resultData => {
        debugger
        var result = JSON.parse(resultData);
        this.spinner.hide();
        if (result != null) {
          if (!result.Status && result.Message === 'AlreadyDeleted') {
            this.AlreadyDeleted = true;
          }
          if (result.Status) {
            this.isUserCanDeleteAccount = true;
           
          } else {
            this.isUserCanDeleteAccount = false;
            this.deleteCustomerAccount();
          }
        }
        else {
          console.log("Some Error occur");
        }
      },
      error => {
        this.spinner.hide();
        if (error.status === 401) {
          this.router.navigate(['/unauthorized']);
        }
        console.log(error);
      });
  }
  deleteCustomerAccount() {
    this.spinner.show();
    if (!this.isUserCanDeleteAccount) {
      this.userdetails = JSON.parse(sessionStorage.getItem('customerinfo'));
      this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
      const UserInfos = {
        EnterprisePartnerID: this.UserInfo.EnterprisePartnerID,
        EmailAddress: this.userdetails.EmailAddress,
        CustomerID: this.userdetails.CustomerID
      };

      this._service.Post(UserInfos, 'api/requestDeleteAccount').then(result => {
        var Data = JSON.parse(result)
        if (Data !== undefined) {
          if (Data.Status) {
            this.mailsentnotification = true;
          }
          else {
            this.mailsentnotification = false;
          }
          this.spinner.hide();
        }
        else {
          console.log('error');
        }
      },
        error => {
          if (error.status === 401) {
            this.router.navigate(['/unauthorized']);
            this.spinner.hide();
          }
          console.log(error);
          throw error;
        });
    }
  }
  Clear() {
    this.activeModal.close('close');
    this._service.fnLogout();
  }
}
